module.exports = __webpack_public_path__ + "static/media/feature_computer_vision.7eea4cb6.png";